import {
  MetricValue,
  NumericMetricValue,
} from 'src/pages/AnalyticsPage/AnalyticsCustomer/AnalyticsCoCustomer.types';

type TicketCountKey =
  | 'resolvedTickets'
  | 'escalatedTickets'
  | 'escalatedOther'
  | 'escalatedUserRequest'
  | 'escalatedKnowledgeGap'
  | 'escalatedModelConfiguration';

type DisplayMetricKey =
  | 'resolutionRate'
  | 'totalProcessedTickets'
  | 'inProgressTickets'
  | 'aiRepliesSent'
  | 'aiRepliesPerProcessedTicket'
  | 'firstResponseTimeAvg'
  | 'responseTimeAvg'
  | 'resolutionTimeAvg';

export const ANALYTICS_COCUSTOMER_INITIAL_STATE: Record<TicketCountKey, NumericMetricValue> &
  Record<DisplayMetricKey, MetricValue> = {
  resolutionRate: {
    value: 'N/A',
    percentage: 0,
  },
  totalProcessedTickets: {
    value: 'N/A',
    percentage: 0,
  },
  resolvedTickets: {
    value: 0,
    percentage: 0,
  },
  escalatedTickets: {
    value: 0,
    percentage: 0,
  },
  escalatedOther: {
    value: 0,
    percentage: 0,
  },
  escalatedUserRequest: {
    value: 0,
    percentage: 0,
  },
  escalatedKnowledgeGap: {
    value: 0,
    percentage: 0,
  },
  escalatedModelConfiguration: {
    value: 0,
    percentage: 0,
  },
  inProgressTickets: {
    value: 'N/A',
    percentage: 0,
  },
  aiRepliesSent: {
    value: 'N/A',
    percentage: 0,
  },
  aiRepliesPerProcessedTicket: { value: 'N/A', percentage: 0 },
  firstResponseTimeAvg: {
    value: 'N/A',
    percentage: 0,
  },
  responseTimeAvg: {
    value: 'N/A',
    percentage: 0,
  },
  resolutionTimeAvg: {
    value: 'N/A',
    percentage: 0,
  },
};
